<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-04 19:27:45
 * @LastEditors: liyong
 * @LastEditTime: 2022-08-03 20:41:46
-->
<template>
	<el-select
		class="select"
		v-bind="$attrs"
		v-model="id"
		:loading-text="loadingText"
		clearable
		:loading="loading"
		filterable
		remote
		:remote-method="remoteMethod"
		@focus="focus"
		@change="change"
		:placeholder="placeholder"
		:multiple="multiple"
		:multiple-limit="multipleLimit"
		:collapse-tags="collapseTags"
	>
		<template v-slot:prefix>
			<div style="width: 20px">
				<i class="el-icon-search ml-4"></i>
			</div>
		</template>
		<el-option v-for="item in options" :key="item.id" :value="item[returnType]" :label="item.anchor_name" class="footer-option">
			<item :item="item"></item>
		</el-option>
	</el-select>
</template>
<script>
import { talentList, teamTalentList } from '@/api/extenTecord';
import Item from './item';
export default {
	props: {
		value: [String, Number, Array],
		placeholder: {
			type: String,
			default: '请选择 / 搜索达人',
		},
		platformId: {
			type: [Number, String],
			default: '',
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		multipleLimit: {
			type: Number,
			default: 0,
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		search_type: {
			type: String,
			default: '1',
		},
		returnType: {
			type: String,
			default: 'id',
		},
	},
	data() {
		return {
			id: this.value,
			loadingText: '加载中',
			loading: false,
			options: [],
		};
	},
	computed: {
		getList() {
			return this.isTeam ? teamTalentList : talentList;
		},
	},
	watch: {
		value(val) {
			this.id = val || [];
		},
	},
	methods: {
		//远程搜索
		async remoteMethod(e) {
			const { search_type } = this;
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data } = await this.getList({ platform_id: this.platformId, anchor_name: e, search_type });
			this.loading = false;
			if (code !== 0) return;
			this.options = this.supplementTalent(data.list);
		},
		async focus(e) {
			const { search_type } = this;
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data } = await this.getList({ platform_id: this.platformId, anchor_name: e.target.value, search_type });
			if (code !== 0) return;
			this.options = this.supplementTalent(data.list);
			data.list.length ? (this.loading = false) : (this.loadingText = '无数据');
		},
		// 多选补充达人
		supplementTalent(list = []) {
			const { options = [], id = [], multiple, returnType } = this;
			if (!multiple) return list;
			const ids = id.reduce((a, b) => ((a[b] = 1), a), {});
			options.forEach(item => ids[item[returnType]] && (ids[item[returnType]] = item));
			list.some(item => {
				if (!Object.keys(ids).length) return true;
				ids[item[returnType]] && Reflect.deleteProperty(ids, item[returnType]);
				return false;
			});
			return [...list, ...Object.values(ids)];
		},
		//选择达人
		change(e) {
			const obj = this.options.find(item => item[this.returnType] === e);
			this.$emit('input', e);
			this.$emit('change', e, obj);
		},
	},
	components: {
		Item,
	},
};
</script>
<style lang="less" scoped>
.footer-option {
	padding: 8px 0px;
	height: auto !important;
	line-height: initial;
}
.select /deep/ .el-select__input {
	margin-left: 30px;
}
</style>